import React, { useState, useContext, useEffect } from 'react';
import styles from './DashboardSidebar.module.scss';
import LogoIcon from 'assets/logo/logo_icon.png';
import Logo from 'assets/logo/logo_full.png';
import AuthenticationService from 'services/AuthenticationService/authentication.service';
import { DashboardSidebarProps } from './constants';
import { useNavigate } from 'react-router-dom';
import InAppNotificationService from 'services/InAppNotificationService/inAppNotification.service';
import { SocketContext } from 'context/SocketContext';
import { useUserContext } from 'context/UserContext';
import DemoVideoModal from '../DemoVideoModal';
import SidebarElements from './sidebarElements';

const DashboardSidebar = () => {
  const [isProductDropdown, setIsProductDropdown] = useState(false);
  const [showVideo, setShowVideo] = useState<boolean>(false);
  const { Logout } = AuthenticationService();
  const { fetchUnreadCount, notificationCount } = InAppNotificationService();
  const navigate = useNavigate();
  const handlePageChange = (index: string) => navigate(`/${index}`);
  const handleSubPageChange = (index: string, subUrl: string) =>
    navigate(`/${index}/${subUrl}`);

  const { fetchCompanyImage, companyImageUrl } = useUserContext();
  const handleCompanyDashboardNavigation = () =>
    handlePageChange(DashboardSidebarProps.COMPANY_DASHBOARD);
  const handleDashboardNavigation = () =>
    handlePageChange(DashboardSidebarProps.DASHBOARD_INDEX);
  const handleCompanySetupNavigation = () =>
    handlePageChange(DashboardSidebarProps.COMPANY_SETUP);
  const handleTargetsNavigation = () =>
    handlePageChange(DashboardSidebarProps.TargetPage);

  const handleProductNavigation = () =>
    handlePageChange(DashboardSidebarProps.PRODUCTS_INDEX);

  const handleValueChainNavigation = () => {
    handleSubPageChange(
      DashboardSidebarProps.VALUE_CHAIN_INDEX,
      DashboardSidebarProps.PROCESSING_FACILITY
    );
  };

  const handleAccountsNavigation = () => {
    handleSubPageChange(
      DashboardSidebarProps.ACCOUNTS_INDEX,
      DashboardSidebarProps.USER_DETAILS
    );
  };

  const handleFarmNavigation = () =>
    handlePageChange(DashboardSidebarProps.FARM_COMMODITY);
  const handleUtilityDashboardNavigation = () =>
    handlePageChange(DashboardSidebarProps.UTILITY_DASHBOARD);

  useEffect(() => {
    if (companyImageUrl === undefined) fetchCompanyImage();
  }, [companyImageUrl]);

  useEffect(() => {
    setTimeout(() => {
      fetchUnreadCount();
    }, 400);
  }, [navigate]);

  const { socket } = useContext(SocketContext);

  const toggleHelpVideoModal = () => setShowVideo(prev => !prev);

  useEffect(() => {
    if (socket) {
      setTimeout(() => {
        socket.on('notification', fetchUnreadCount);
      }, 400);
      return () => {
        socket.off('notification', () => {});
      };
    }
  }, [socket]);

  return (
    <>
      <div className={styles.sidebarWrapper}>
        <div className={styles.sidebarContainer}>
          <div onMouseLeave={() => setIsProductDropdown(false)}>
            {/* For Company and default logo icon start */}
            <div className={styles.iconContainer}>
              <div className={styles.logoContainer}>
                {companyImageUrl ? (
                  <img
                    src={companyImageUrl}
                    alt={DashboardSidebarProps.CLIENT_LOGO_ALT}
                    className={styles.clientLogo}
                  />
                ) : (
                  <div className={styles.clientLogo}></div>
                )}
              </div>
            </div>
            {/* For Company and default logo icon end */}
            <SidebarElements
              isProductDropdown={isProductDropdown}
              setIsProductDropdown={setIsProductDropdown}
              handleCompanyDashboardNavigation={
                handleCompanyDashboardNavigation
              }
              handleCompanySetupNavigation={handleCompanySetupNavigation}
              handleDashboardNavigation={handleDashboardNavigation}
              handleProductNavigation={handleProductNavigation}
              handleValueChainNavigation={handleValueChainNavigation}
              handleAccountsNavigation={handleAccountsNavigation}
              handleTargetsNavigation={handleTargetsNavigation}
              handleFarmNavigation={handleFarmNavigation}
              handleUtilityDashboardNavigation={handleUtilityDashboardNavigation}
              toggleHelpVideoModal={toggleHelpVideoModal}
              fetchUnreadCount={fetchUnreadCount}
              notificationCount={notificationCount}
              Logout={Logout}
            />
          </div>
        </div>
        <div className={styles.bottomItemContainer}>
          <div className={styles.defaultBottomView}>
            <img
              src={Logo}
              alt={DashboardSidebarProps.SIDEBAR_BOTTOM_BACKGROUND}
              className={styles.coLogo}
            />
          </div>

          <div className={styles.hoverBottomView}>
            <img
              src={LogoIcon}
              alt={DashboardSidebarProps.SIDEBAR_BOTTOM_BACKGROUND}
              className={styles.coLogo}
            />
          </div>
        </div>
      </div>
      <DemoVideoModal showVideo={showVideo} setShowVideo={setShowVideo} />
    </>
  );
};

export default DashboardSidebar;
